import { fetchAuthSession } from 'aws-amplify/auth';
/**
 * JwtTokenを取得する
 * @returns トークン (ログインしていなければ空文字)
 */
export const getTokens = async () => {
  try {
    const session = await fetchAuthSession();
    const jwtToken = session.tokens?.idToken?.toString() ?? '';
    const accessToken = session.tokens?.accessToken?.toString() ?? '';
    return { jwtToken, accessToken };
  } catch (error) {
    return { jwtToken: '', accessToken: '' };
  }
};
